import type { LocalResponse } from '../types';

const HISTORY_KEY = 'doubt-atlas.v1.localHistory';

export function readHistory(): LocalResponse[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]') as LocalResponse[];
    return Array.isArray(parsed) ? parsed.slice(-120) : [];
  } catch {
    return [];
  }
}

export function appendHistory(item: LocalResponse): LocalResponse[] {
  const next = [...readHistory(), item].slice(-120);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(next));
  return next;
}

export function clearHistory(): void {
  localStorage.removeItem(HISTORY_KEY);
}

export function formatMs(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}
